import { render, staticRenderFns } from "./SalesPeriodsList.vue?vue&type=template&id=70913570&scoped=true&"
import script from "./SalesPeriodsList.vue?vue&type=script&lang=js&"
export * from "./SalesPeriodsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70913570",
  null
  
)

export default component.exports